

export function SummaryCard({ label, value, tone, testid }) {
  const bar = tone === "up" ? "border-l-[#2F6B4A]"
            : tone === "down" ? "border-l-[#B4283A]"
            : "border-l-[var(--brand)]";
  return (
    <div data-testid={testid}
         className={`card-flat p-3 border-l-4 ${bar}`}>
      <div className="text-[10px] tracking-[0.18em] uppercase text-[var(--muted-text)]">{label}</div>
      <div className="font-mono-data text-lg font-semibold mt-1 truncate">{value}</div>
    </div>
  );
}
